<div fxLayout="column" fxLayoutAlign="center center">
    <ngx-avatar
        mat-card-avatar
        [src]="leader.userSummary?.avatarUrl || null"
        [name]="
            leader.userSummary ? leader.userSummary.name + ' ' + leader.userSummary.surname : leader.groupSummary?.name
        "
        [size]="60"
        [class.logged-user]="loggedUserId == leader.userId || userIsInTheGroup(leader.groupId)"
    >
    </ngx-avatar>

    <div
        class="position"
        [class.first-place]="leader.position == 0"
        [class.second-place]="leader.position == 1"
        [class.third-place]="leader.position == 2"
        [class.logged-user-infos]="loggedUserId == leader.userId || userIsInTheGroup(leader.groupId)"
    >
        {{ leader.position + 1 }}
    </div>
</div>

<div
    fxLayout="column"
    class="leader-infos"
    [class.logged-user-infos]="loggedUserId == leader.userId || userIsInTheGroup(leader.groupId)"
>
    <div class="leader-name text-truncate" fxLayout="row" fxLayout="center center">
        {{
            leader.userSummary ? leader.userSummary.name + " " + leader.userSummary.surname : leader.groupSummary?.name
        }}
    </div>
    <div class="points" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
        <mat-icon>grade</mat-icon>
        {{ leader.points }}pts
    </div>
</div>
